import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6 text-primary">Privacy Policy</h1>
      
      <p className="mb-4 text-muted-foreground">Effective Date: 12/09/2024</p>
      
      <p className="mb-6">
        Welcome to Crece LL! Your privacy is important to us, and we are committed to protecting your personal information. 
        This Privacy Policy explains how we collect, use, and safeguard your information when you use our GPT-powered app, 
        designed to provide purely informational responses to legal questions for Spanish-speaking individuals.
      </p>
      
      <p className="mb-6">By using our app, you agree to the terms of this Privacy Policy.</p>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">1. Information We Collect</h2>
        <p className="mb-4">We collect the following information from our users:</p>
        <ul className="list-disc pl-6 mb-4 space-y-2">
          <li>Personal Information: Name, email address, and phone number.</li>
          <li>User-Generated Content: Legal questions or other information you provide when using the app.</li>
          <li>Usage Data: Device type, browser type, and interaction data to enhance your experience.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">2. How We Use Your Information</h2>
        <ul className="list-disc pl-6 mb-4 space-y-2">
          <li>To provide responses to your legal questions.</li>
          <li>To improve our app's functionality and user experience.</li>
          <li>To send you updates or notifications about changes to our services or policies.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">3. How Long We Retain Your Information</h2>
        <p className="mb-4">
          We retain your data for up to two (2) years in a secure database managed through SupaBase. 
          After this period, your data will be deleted unless required for legal or regulatory purposes.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">4. How We Protect Your Information</h2>
        <p className="mb-4">
          We take security seriously and use SupaBase's robust security protocols to safeguard your data. 
          While we strive to protect your personal information, no method of transmission over the Internet 
          or electronic storage is 100% secure.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">5. Your Rights</h2>
        <p className="mb-4">
          If you are a resident of California, you have rights under the California Consumer Privacy Act (CCPA), including:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2">
          <li>Access to Information: The right to request access to the personal information we have collected about you.</li>
          <li>Deletion Requests: The right to request that we delete your personal information, subject to certain legal exceptions.</li>
        </ul>
        <p className="mb-4">
          To exercise these rights, please contact us at our toll-free number: [Insert Toll-Free Number].
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">6. Third-Party Data Sharing</h2>
        <p className="mb-4">We do not share your personal information with any third parties.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">7. Updates to This Privacy Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. If changes are made, we will notify you 
          through the app or via email.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-primary">8. Contact Us</h2>
        <p className="mb-4">If you have questions or concerns about this Privacy Policy, please contact us:</p>
        <div className="pl-6">
          <p>Crece LL</p>
          <p>Toll-Free Number: [Insert Toll-Free Number]</p>
          <p>Email: [Insert Email Address]</p>
        </div>
      </section>
      
      <section className="mb-8">
        <p className="mb-4">
          Note for California Residents: For more details about your rights under the CCPA, please visit 
          California Consumer Privacy Act.
        </p>
      </section>
      
      <p className="mt-8 text-muted-foreground">
        By continuing to use our app, you acknowledge that you have read and understood this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;